import analyticsServiceImpl from '../analytics-service';
import type { AnalyticsService } from './contracts';

export type { AnalyticsService } from './contracts';
export { AnalyticsActionType, AnalyticsEvent, AnalyticsSubTypeEvent } from '../analytics-event';
export { AnalyticsTypes } from '../analytics-types';
export { default as TrackingInit } from '../tracking-init';
export const analyticsService: AnalyticsService = analyticsServiceImpl;
